export const NewsListSelector = (state) => state.news.newsList;
export const NewsDetailSelector = (state) => state.news.newsDetails;